import type { HTMLAttributes, ReactNode } from 'react';

type Props = {
  variant?: 'surface' | 'child';
  children: ReactNode;
} & HTMLAttributes<HTMLDivElement>;

export function Card({ variant = 'surface', className = '', children, ...rest }: Props) {
  const base =
    'rounded-lg border-hairline border-border p-4 sm:p-5';
  const skin =
    variant === 'child' ? 'bg-child-fill text-child-text' : 'bg-surface text-ink';
  return (
    <div className={[base, skin, className].join(' ')} {...rest}>
      {children}
    </div>
  );
}
